export default __webpack_public_path__ + "ea12404841bc3f55a3c5a9e19011e778.jpg";